export default __webpack_public_path__ + "static/media/GTorpedoOpen.88edec4c.jpg";